import React from 'react';
import { BillingPosition } from './wizardTypes';

interface WizardStep2Props {
    positions: BillingPosition[];
    newPosition: BillingPosition;
    setNewPosition: (position: BillingPosition) => void;
    addPosition: () => void;
    removePosition: (id: string) => void;
}

const WizardStep2: React.FC<WizardStep2Props> = ({
    positions,
    newPosition,
    setNewPosition,
    addPosition,
    removePosition,
}) => {
    return (
        <div className="wizard-step">
            <h3>Rechnungspositionen</h3>
            
            {positions.length > 0 && (
                <div className="positions-list">
                    {positions.map(pos => (
                        <div key={pos.id} className="position-item">
                            <div className="position-content">
                                <div className="position-description">{pos.description}</div>
                                <div className="position-details">
                                    {pos.priceType === 'fixed' ? (
                                        <span>Festpreis: {pos.amount.toFixed(2)} €</span>
                                    ) : (
                                        <span>Pro Tabler: {pos.amount.toFixed(2)} €</span>
                                    )}
                                    <span> • Steuersatz: {pos.taxRate}%</span>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="position-remove-btn"
                                onClick={() => removePosition(pos.id)}
                            >
                                ✕
                            </button>
                        </div>
                    ))}
                </div>
            )}

            <div className="add-position-form">
                <div className="form-group">
                    <label htmlFor="description">Beschreibung</label>
                    <input
                        type="text"
                        id="description"
                        value={newPosition.description}
                        onChange={(e) => setNewPosition({ ...newPosition, description: e.target.value })}
                        placeholder="z.B. Raummiete, Catering, etc."
                    />
                </div>

                <div className="form-group">
                    <label>Preistyp</label>
                    <div className="radio-group">
                        <label className="radio-label">
                            <input
                                type="radio"
                                value="fixed"
                                checked={newPosition.priceType === 'fixed'}
                                onChange={(e) => setNewPosition({ ...newPosition, priceType: e.target.value as 'fixed' | 'perTabler' })}
                            />
                            <span>Festpreis</span>
                        </label>
                        <label className="radio-label">
                            <input
                                type="radio"
                                value="perTabler"
                                checked={newPosition.priceType === 'perTabler'}
                                onChange={(e) => setNewPosition({ ...newPosition, priceType: e.target.value as 'fixed' | 'perTabler' })}
                            />
                            <span>Preis pro Tabler</span>
                        </label>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="amount">Betrag</label>
                    <div className="input-with-symbol">
                        <input
                            type="number"
                            id="amount"
                            value={newPosition.amount === 0 ? '0' : newPosition.amount || ''}
                            onChange={(e) => setNewPosition({ ...newPosition, amount: parseFloat(e.target.value) || 0 })}
                            placeholder="0.00"
                            step="0.01"
                            min="0"
                        />
                        <span className="currency-symbol">€</span>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="taxRate">Steuersatz</label>
                    <div className="input-with-symbol">
                        <input
                            type="number"
                            id="taxRate"
                            value={newPosition.taxRate === 0 ? '0' : newPosition.taxRate || ''}
                            onChange={(e) => setNewPosition({ ...newPosition, taxRate: parseFloat(e.target.value) || 0 })}
                            placeholder="19"
                            step="1"
                            min="0"
                            max="100"
                        />
                        <span className="currency-symbol">%</span>
                    </div>
                </div>

                <button
                    type="button"
                    className="wizard-btn wizard-btn-add"
                    onClick={addPosition}
                >
                    Position hinzufügen
                </button>
            </div>
        </div>
    );
};

export default WizardStep2;
